module.exports = __webpack_public_path__ + "static/media/cuadricula.e9f26b9c.svg";